<template>
  <div>
    <b-container class="p-relative">
      <div class="header-text-container">
        <div class="header-text">Update Board Layout</div>
      </div>
    </b-container>

    <div class="cover-image">
      <div class="cover-overlay"></div>
    </div>

    <b-container
      class="my-5"
      :class="isMobile ? 'mb-5' : 'w-50 form-container'"
    >
      <board-layout-information />
    </b-container>
  </div>
</template>

<script>
import BoardLayoutInformation from '@/components/forms/board/BoardLayoutInformation'
import { mapActions } from 'vuex'

export default {
  components: {
    BoardLayoutInformation
  },

  methods: {
    ...mapActions({
      getBoardDetails: 'board/getBoardDetails'
    })
  },

  async created() {
    await this.getBoardDetails(this.$route.params.id)
    this.$root.$emit('boardLayoutLoaded')
  }
}
</script>

<style scoped>
.header-text-container {
  position: absolute;
  color: white;
  top: 95px;
  z-index: 2;
}
.header-text {
  font-size: 24px;
  font-weight: bold;
}
.cover-image {
  width: 100%;
  min-height: 160px;
  background: url('~@/assets/images/cover.jpeg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.9;
}
.cover-overlay {
  width: 100%;
  min-height: 160px;
  background-blend-mode: multiply;
  background: transparent url('~@/assets/images/overlay.svg') 0% 0% no-repeat
    padding-box;
  background-size: cover;
  background-repeat: no-repeat;
}
.form-container {
  position: relative;
  margin-left: 10%;
  margin-bottom: 100px;
}
</style>
